import styled from "styled-components";

export const Wrapper = styled.div`
  .side-cart {
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 111;
    path {
      transition: 0.2s ease-in-out;
    }
    svg polyline,
    svg line,
    svg {
      stroke: #fff;
      stroke-linecap: round;
      stroke-linejoin: round;
      transition: 0.2s;
      margin-top: 20rem;
      &:hover path:first-child {
        fill: #6b9524;
      }
      &:hover path:nth-child(2),
      &:hover path:nth-child(3),
      &:hover path:nth-child(4) {
        stroke: white;
      }
    }

    svg {
      cursor: pointer;
    }
  }
`;
export const CovidContainer = styled.div`
  background-color: #f7f7f7;
  height: 50px;
  z-index: 1;
  p {
    margin: 0 16px;
    font-size: 13px;
    color: #000;
  }
  span {
    color: #08694a;
    cursor: pointer;
    font-weight: 500;
    transition: 0.5s ease-in-out 0.04s;
    &:hover {
      font-weight: 700;
    }
  }
`;

export const CustomButton = styled.button`
  background-color: #08694a;
  border-radius: 30px;
  outline: none;
  border: 0;
  color: #fff;
  padding: 15px 20px;
  font-weight: 500;
  transition: all ease-in 0.2s 0.09s;
  border: 0.5px solid #fff;
  margin-left: 24px;
  &:hover {
    background-color: #fff;
    color: #08694a;
    border: 0.5px solid #08694a;
  }
`;
